export default __webpack_public_path__ + "static/tiempos-text-web-regular-6dc74e068a907bc91b4c22c40b2ca203.eot";